import { GradientDef, LogoColor } from '@vp/algo-design-logo-composer'
import { ComposeLogoRequest, LogoTextColor } from '@vp/algo-design-logo-composer/lib/api/interfaces/studioInterfaces'

export const LayoutsOtherThanCircular = {
  STACKEDV3_1: 'stackedV3_1',
  STACKEDV3_2: 'stackedV3_2',
  SIDEBYSIDE_1: 'sideByside_1',
  SIDEBYSIDE_2: 'sideByside_2',
  ARCICONLAYOUT: 'archIconLayout',
  ICONINMIDDLELAYOUT: 'iconInMiddleLayout',
  TEXT_SOLID_CONTAINER: 'text_solid_container',
}

export function isGradient(color: LogoTextColor | LogoColor | undefined): color is GradientDef {
  return (color as GradientDef)?.stopColors !== undefined
}

export const isGradientInLogo = (signature: ComposeLogoRequest): boolean => {
  if (
    isGradient(signature.icon?.colors[0]?.override || signature.icon?.colors[0]?.default) ||
    isGradient(signature.icon?.containerRequest?.container.color.override || signature.icon?.containerRequest?.container.color.default) ||
    isGradient(signature.monogram?.text.color.override || signature.monogram?.text.color.default) ||
    isGradient(signature.monogram?.container.color.override || signature.monogram?.container.color.default) ||
    isGradient(signature.companyName.color.override || signature.companyName.color.default) ||
    isGradient(signature.tagline?.color.override || signature.tagline.color.default)
  ) {
    return true
  }
  return false
}
